<template>
    <div>
        <div v-if="selMenu == 'b2cTis50'" class="sebMenu">
            <ul>
                <li :class="num.includes('m01') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis50','m0100')">Product Information</a></li>
                <li :class="num.includes('m02') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis50','m0200')">Install and Uninstall</a></li>
                <li :class="num.includes('m03') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis50','m0300')">Main Inquiry</a></li>
                <li class="borderLine export"><a href="https://tachyonlab.com/en/b2c/tis">Download</a></li>
                <li class="borderLine export"><a href="https://tachyonlab.com/en/b2c/tis">About Product  </a></li>
                <li class="borderLine export"><a href="https://tachyonlab.com/en/secu_supp/secu_supp/0">Security Analysis & Response Center(ISARC)</a></li>
            </ul>
        </div>
        <div v-if="selMenu == 'b2cTis60'" class="sebMenu">
            <ul>
                <li :class="num.includes('m01') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis60','m0100')">Product Information</a></li>
                <li :class="num.includes('m02') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis60','m0200')">Install and Uninstall</a></li>
                <li :class="num.includes('m03') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2cTis60','m0300')">Main Inquiry</a></li>
                <li class="borderLine export"><a href="/en/b2c/tis60">Download</a></li>
                <li class="borderLine export"><a href="/en/b2c/tis60">About Product  </a></li>
                <li class="borderLine export"><a href="/en/secu_supp/secu_supp/0">Security Analysis & Response Center(ISARC)</a></li>
            </ul>
        </div>
        <div v-if="selMenu == 'b2bTes50'" class="sebMenu">
            <ul>
                <li :class="num.includes('m01') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2bTes50','m0100')">Product Information</a></li>
                <li :class="num.includes('m02') ? 'borderLine fontSel':'borderLine' "><a  @click="selectMenu('b2bTes50','m0200')">Main Inquiry</a></li>
                <li class="borderLine export"><a href="https://tachyonlab.com/en/b2b/tes">About Product</a></li>
                <li class="borderLine export"><a href="https://tachyonlab.com/en/secu_supp/secu_supp/0">Security Analysis & Response Center(ISARC)</a></li>
            </ul>
        </div>
        <div v-if="selMenu == 'common'" class="sebMenu">
            <ul>
                <li :class="num.includes('m01') ? 'borderLine fontSel':'borderLine' "><a @click="selectMenu('common','m0100')">Main Inquiry</a></li>
                <li class="borderLine export"><a onclick="window.open('/en/main_level','window_name','width=780,height=930,location=no,status=no,scrollbars=yes');" style="cursor:pointer;">Security Alert Levels and Malware naming</a></li>
            </ul>
        </div>
        <div v-if="selMenu == 'sel'" class="sebMenu">
            <ul>
                <li class="borderLine export"><a href="https://my.tachyonlab.com/my/sin/signInFRM?lang=en" target="_blank">Manage Account</a></li>
            </ul>
        </div> 
    </div>
</template>

<script>

export default {
    name: 'CsSidebar',
    mounted : function() {
        this.selMenu = this.$route.params.code;
        this.num = this.$route.params.no;
    },
    data: function() {
        return {
            selMenu : "",
            num : "",
        }
    },
    methods: {
        selectMenu(userType, no) {
            window.location.href= '/cs/en/' + userType + '/' + no;
           
        },
    }
}
    
   
</script>
